import React, { Component } from 'react';
import '../Styles/FooterStyle.css';

export class Footer extends Component {
    displayName = this.name



    render() {
        return (
            <div>
                <div style={{ marginTop: "30px", backgroundColor:"#7c5295", color: "white"}}>
                    <div className="container" style={{padding:"10px"}}>
                        <div className="row" style={{margin:"auto"}}>
                            <div className="col-md-4">
                                <p className="footer-text">Calloway's Health and Fitness</p>
                                <p className="footer-text">225-756-0662</p>
                                <p className="footer-text">13436 Jefferson Hwy</p>
                                <p className="footer-text">www.callowaysfitness.com</p>
                            </div>
                            <div className="col-md-4">
                                <p className="quote-text">
                                    <i>"Every day is another chance to get stronger, to eat better, to live healthier and to be the best version of you"</i>
                                </p>
                            </div>
                            <div className="col-md-4">
                            <p style={{ textAlign: "center", margin:"auto" }}><u>Hours of Operation</u></p>
                                <table className="footer-table">
                                    <tbody>
                                        <tr>
                                            <td className="footer-td">Monday - Thursday</td>
                                            <td className="footer-td">4:15 AM - 10:00 PM</td>
                                        </tr>
                                        <tr>
                                            <td className="footer-td">Friday</td>
                                            <td className="footer-td">4:15 AM - 9:00 PM</td>
                                        </tr>
                                        <tr>
                                            <td className="footer-td">Saturday</td>
                                            <td className="footer-td">8:00 AM - 4:00 PM</td>
                                        </tr>
                                        <tr>
                                            <td className="footer-td">Sunday</td>
                                            <td className="footer-td">10:00 AM - 6:00 PM</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                    <div className="row" style={{ "margin": "auto", textAlign: "center" }}>
                        <p className="my-foot-text" style={{ "paddingBottom": "20px" }}>© {(new Date().getFullYear())} <a href="/">Calloway's Health & Fitness</a> | All Rights Reserved <br /> Created By <a target="_blank" rel="noopener noreferrer" href="https://bluecowcode.com">Bluecowcode.com</a>.</p>
                    </div>
                </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Footer.js